import {useQuery} from "@tanstack/react-query";
import {useCustomerScanContext} from "./scan-model/CustomerScanContext.tsx";
import {useAtomValue, useSetAtom} from "jotai";
import {ApiAtom} from "../../common-process/1-metl-connection/MetlConnectionProperties.ts";
import {CustomerAnalysisOptionsAtom} from "../1-options/CustomerAnalysisOptions.ts";
import {performWorkloadScan} from "./scan-operations/performWorkloadScan.ts";
import {Button} from "@matillion/component-library";
import {ScanningDisplay} from "../../analysis-process/3-perform-scan/scan-display/ScanningDisplay.tsx";
import {WorkloadScanAtom} from "./WorkloadScanAtom.tsx";
import {useStepContext} from "../../components/stepper/StepContext.ts";
import {errorText} from "../../analysis-process/3-perform-scan/scan-operations/error/ErrorText.ts";

export function CustomerWorkloadScanWidget() {
    const api = useAtomValue(ApiAtom)
    const options = useAtomValue(CustomerAnalysisOptionsAtom)
    const { lock: lockStep } = useStepContext()
    const [scanContext, scanDisplayInfo] = useCustomerScanContext()
    const setScanResult = useSetAtom(WorkloadScanAtom)
    
    const query = useQuery({
        queryKey: ["customer-workload-scan", api?.id ?? "unknown", "options", options.id],
        queryFn: () => {
            return lockStep(async () => {
                const result = await performWorkloadScan(scanContext)
                setScanResult(result)
                return result
            })
        },
        enabled: false,
        gcTime: Infinity,
        staleTime: Infinity,
        retry: false
    })

    if(!query.data && !query.isLoading && !query.isError && !query.isFetching) {
        return <div>
            <h2>Scan Workloads</h2>
            <p>Scan projects to build workload analysis data including jobs, schedules, and task history.</p>
            <Button onClick={() => query.refetch()}>Start Scan</Button>
        </div>
    }

    return <div>
        <h2>Scan Workloads</h2>
        <div>
            <h3>Scan Progress</h3>
            <ScanningDisplay display={scanDisplayInfo} />
        </div>
        {query.isError && <pre>
            An error occurred while scanning data. Scan has been aborted. {errorText(query.error)}
        </pre>}
        {query.data && <div>
            <h3>Scan Complete</h3>
            <p>
                Successfully scanned {query.data.workloadInputs.length} project(s) and identified {query.data.workloads.length} workload(s).
            </p>
            <p>
                Proceed to the next step to view your results and recommendations.
            </p>
            {query.data.scanErrors.length > 0 && (
                <div>
                    <h4>Scan Errors ({query.data.scanErrors.length})</h4>
                    <ul>
                        {query.data.scanErrors.map((error, idx) => (
                            <li key={idx}>{error}</li>
                        ))}
                    </ul>
                </div>
            )}
        </div>}
    </div>
}
